import { TranslationKey } from '../translations/TranslationKey';
import { ExamDayType } from './ExamDayType';

export type TimeSlotStructure = { [type in TimeSlotStructureType]: TimeSlot[] };

export enum TimeSlotStructureType {
  OralHBB_ProcessModule = 'OralHBB_ProcessModule',
  OralIntermediary = 'OralIntermediary',
  ElectiveWritten = 'ElectiveWritten',
  WrittenHBB_ProcessModule = 'WrittenHBB_ProcessModule',
  WrittenIntermediary = 'WrittenIntermediary',
  Correction = 'Correction',
  MandatoryWritten = 'MandatoryWritten',
  OralLife = 'OralLife',
}

export enum TimeSlotType {
  Exam = 0,
  Briefing = 1,
  Break = 2,
}

export interface TimeSlot {
  index?: number;
  startTime: string;
  endTime: string;
  arrivalTime: string | null;
  type?: TimeSlotType;
}

export const TimeSlotStructureLabels: { [structure in TimeSlotStructureType]: TranslationKey } = {
  [TimeSlotStructureType.OralHBB_ProcessModule]: 'examDay.field.timeSlotStructure.oralHBB_ProcessModule',
  [TimeSlotStructureType.OralIntermediary]: 'examDay.field.timeSlotStructure.oralIntermediary',
  [TimeSlotStructureType.ElectiveWritten]: 'examDay.field.timeSlotStructure.electiveWritten',
  [TimeSlotStructureType.WrittenHBB_ProcessModule]: 'examDay.field.timeSlotStructure.writtenHBB_ProcessModule',
  [TimeSlotStructureType.WrittenIntermediary]: 'examDay.field.timeSlotStructure.writtenIntermediary',
  [TimeSlotStructureType.Correction]: 'examDay.field.timeSlotStructure.correction',
  [TimeSlotStructureType.MandatoryWritten]: 'examDay.field.timeSlotStructure.mandatoryWritten',
  [TimeSlotStructureType.OralLife]: 'examDay.field.timeSlotStructure.oralLife',
};

export const getRoomTypeFromSelectedTimeSlot = (selectedTimeSlot?: TimeSlotStructureType): ExamDayType | string => {
    if (!selectedTimeSlot) {
      return "";
    }
    switch (selectedTimeSlot) {
      case TimeSlotStructureType.OralHBB_ProcessModule:
      case TimeSlotStructureType.OralIntermediary:
      case TimeSlotStructureType.OralLife:
        return ExamDayType.Oral;
      case TimeSlotStructureType.Correction:
        return ExamDayType.Correction;
      default:
        return ExamDayType.Written;
    }
  };